import React, {
    Dispatch,
    MouseEventHandler,
    ReactNode,
    SetStateAction,
} from 'react';

import TranslationHelper from '../../../../helpers/TranslationHelper';

import {
    findIndexById,
    intersection,
    not,
    union,
} from '../../helpers/filterObjects';
import { ITransferListObject } from '../../CommonTransferList';
import CustomList from '../CustomList';
import { NameFilter } from '../filters/NameFilter';
import { TypeFilter } from '../filters/TypeFilter';

interface IOwnProps<T> {
    loaded: boolean;
    typeInput: {
        type: string;
        setType: (value: string) => void;
    };
    nameInput: {
        name: string;
        setName: (value: string) => void;
    };
    title: string;
    items: T[];
    handleToggle: (value: T) => MouseEventHandler | undefined;
    checked: T[];
    setChecked: Dispatch<SetStateAction<T[]>>;
    types: string[];
    tooltipTitle?: string;
    disabled?: boolean;
}

const CommonCustomList = <T extends ITransferListObject>({
    loaded,
    typeInput,
    nameInput,
    items,
    handleToggle,
    title,
    checked,
    setChecked,
    tooltipTitle,
    types,
}: IOwnProps<T>) => {
    const getUniqueKey = (item: T): string => {
        return item.relationId + item.type;
    };
    const filterComponents = (): ReactNode => {
        return (
            <>
                <NameFilter
                    id={'nameFilter'}
                    label={'Find...'}
                    nameInput={nameInput}
                    tooltipTitle={tooltipTitle}
                />
                <TypeFilter
                    label={'Type'}
                    typeInput={typeInput}
                    types={types}
                />
            </>
        );
    };

    return (
        <CustomList<T>
            loaded={loaded}
            title={title}
            items={items}
            handleToggle={handleToggle}
            checked={checked}
            setChecked={setChecked}
            utils={{ intersection, union, not, findIndexById }}
            renderSecondary={(item: any) =>
                `${TranslationHelper.translate(`assignType.${item.type}`)} ${
                    item.address ?? ''
                }`
            }
            uniqueKey={getUniqueKey}
            filterComponents={filterComponents}
        />
    );
};

export default CommonCustomList;
